<template>
  <div class="alarm-most-acted__wrapper">
    <dashboard-items-header
    class="alarm-most-acted__title"
      :title="$t('dashboard.most-acted.title')"
      :periodDays="periodDays"
      @onClickPeriodFilter="onClickPeriodFilterHandler"
    />
    <s-table
      :items="itemsSorted"
      :fields="fields"
      :busy="loading"
      @row-clicked="onSelection"
    >
      <template #cell(totalActedCount)="{ item }">
        <b-progress
          class="sprogress"
          :max="maxValue"
        >
          <b-progress-bar
            class="sprogress-bar"
            :value="item.totalActedCount"
          />
          <span class="sprogress-value">{{ item.totalActedCount }}</span>
        </b-progress>
      </template>
      <template #cell(moduleName)="{ item }"
        class="asset-list__cell-module-name"
          >
        {{ `${getModuleDisplayName(item.moduleName)} - ${item.alarmName}`}}
      </template>
      <template #cell(lastAlarmDateTime)="{ item }">
        {{ item.lastAlarmDateTime | dateTimeFilter }}
      </template>
    </s-table>
  </div>
</template>

<script>
import { AlarmHistoryStatusFilter } from 'sigma-mappings';
import Service from '@/domain/services/generalPanel/dashboard';
import DashboardItemsHeader from '@/components/header/DashboardItemsHeader';
import getModuleDisplayName from '@/services/moduleDisplayName';
import translate from '@/services/translate';
import periods from '@/domain/enums/periods-dropdown-filter';
import AlarmsReportMixin from '@/domain/mixins/generalPanel/reports/alarmsReportMixin';
import {
  getInitialDate,
  getStartOfDay,
  getEndOfDay,
  minus,
} from '@/services/dateTime/datetimeService';

export default {
  props: {
    filters: {
      type: Object,
      required: true,
    },
    amountAlarms: {
      type: Number,
      default: 5,
    },
  },
  components: {
    DashboardItemsHeader,
  },
  mixins: [AlarmsReportMixin],
  computed: {
    maxValue() {
      return this.listData.reduce(
        (max, item) => (item.totalActedCount > max ? item.totalActedCount : max), 0,
      );
    },
    itemsSorted() {
      return (this.listData || []).sort(
        (a, b) => (a.totalActedCount < b.totalActedCount ? 1 : -1),
      );
    },
    getFilterPayload() {
      return {
        ...this.filters,
        periodDays: this.periodDays,
        amountAlarms: this.amountAlarms,
      };
    },
  },
  data: () => ({
    periodDays: periods.ALL,
    listData: [],
    loading: true,
    fields: [
      {
        key: 'totalActedCount',
        sortable: false,
        label: translate('dashboard.most-acted.fields.total-acted'),
        class: 'asset-list__cell-total-times-acted',
      },
      {
        key: 'moduleName',
        sortable: false,
        label: translate('dashboard.most-acted.fields.module-name'),
        class: 'asset-list__cell-module-name',
      },
      {
        key: 'affectedAssetsCount',
        sortable: false,
        label: translate('dashboard.most-acted.fields.affected-assets'),
        class: 'asset-list__cell-affected-assets',
      },
      {
        key: 'lastAlarmDateTime',
        sortable: false,
        label: translate('dashboard.most-acted.fields.date-time'),
        class: 'asset-list__cell-date-time',
      },
    ],
  }),
  methods: {
    getModuleDisplayName,
    loadListData() {
      this.loading = true;
      Service
        .getMostActedAlarms(this.getFilterPayload)
        .then((response) => {
          this.listData = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickPeriodFilterHandler(newPeriod) {
      this.periodDays = newPeriod;
      this.loadListData();
    },
    getStartingDate() {
      if (this.periodDays === periods.ALL) {
        return getInitialDate();
      }
      return minus(getStartOfDay(), { days: this.periodDays - 1 });
    },
    onSelection(params) {
      const filter = {
        alarmsIds: [params?.alarmId],
        status: [
          AlarmHistoryStatusFilter.ACTED_NOT_RECOGNIZED,
          AlarmHistoryStatusFilter.ACTED_RECOGNIZED,
          AlarmHistoryStatusFilter.NOT_ACTED_NOT_RECOGNIZED,
          AlarmHistoryStatusFilter.NOT_ACTED_RECOGNIZED,
        ],
        initialDateTime: this.getStartingDate(),
        finalDateTime: getEndOfDay(),
        companiesIds: this.filters.companiesIds,
        installationsIds: this.filters.installationsIds,
        regionalIds: this.filters.regionalsIds,
      };
      this.openAlarmReport(filter);
    },
  },
};
</script>

<style lang="sass" scoped>
.alarm-most-acted__title
  margin-bottom: 1.7rem
.sprogress
  display: flex
  align-items: center
  background-color: transparent
  &-bar
    border-radius: 10px
    height: 12px
    background-color: var(--color-secondary-light)
  &-value
    padding-left: 5px

::v-deep
  .table
    background-color: transparent
    min-width: 55rem
    td
      border-top: 1px solid var(--color-border-table-row)
    thead th
      background-color: transparent
      color: var(--font-color-secondary)
      font-weight: 400
      font-size: 0.85rem
    &.table-striped
      tbody
        tr:nth-of-type(2n)
          background-color: transparent
    &.table-hover
      tbody
        tr:hover
          background-color: rgba(0, 0, 0, 0.06)
          cursor: pointer

.asset-list
  ::v-deep &__cell
    &-module-name
      text-align: left !important
      &:not(th)
        height: 4rem
      min-width: 49.78%
      white-space: nowrap
    &-affected-assets
      width: 10.69%
    &-affected-assets
      text-align: right !important
    &-date-time
      width: 21.26%
    &-total-times-acted
      width: 19.27%
      text-align: left !important
</style>
